// @flow
import * as React from "react";

import getInitials from "utils/getInitials";

type Props = {
  alt: string,
};

function Avatar({ alt }: Props): React.Node {
  return <span className="Avatar Avatar--placeholder">{getInitials(alt)}</span>;
}

export default Avatar;
